/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import ButtonComponent from 'components/buttons/button';
import IntlMessageComponent from 'components/formatters/intlMessage';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';

type InvoiceRefusalConfirmationViewComponentProps = {
  restart: () => void;
}

export default function InvoiceRefusalConfirmationViewComponent(props: InvoiceRefusalConfirmationViewComponentProps) {
  return (
    <React.Fragment>
      <PageSubTitleViewComponent id="component.debtor.invoices.refused.title" />

      <Typography variant="body1">
        <IntlMessageComponent id="component.debtor.invoices.refused.description" />
      </Typography>
      
      <Box mt={5}>
        <ButtonComponent
          color="primary"
          variant="contained"
          onClick={props.restart}
        ><IntlMessageComponent id="general.back" /></ButtonComponent>
      </Box>
    </React.Fragment>
  );
}
